/* Presentation and consent-aware clicks only; Shopify calculates every discount. */
(() => {
  const node = document.getElementById('pf-promotion-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const campaigns = {GB: 'uk-b2g1-20261001', US: 'us-b2g1-20261001'};
  if (typeof config.marketCountry !== 'string'
      || !Object.prototype.hasOwnProperty.call(campaigns, config.marketCountry)
      || config.campaignId !== campaigns[config.marketCountry]
      || config.endsAt !== null || config.eligibleCount !== 377
      || !Array.isArray(config.handles) || config.handles.length !== 377
      || config.handles.some(handle => typeof handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(handle))
      || typeof config.noteText !== 'string' || !config.noteText) return;
  const eligible = new Set(config.handles);
  if (eligible.size !== 377) return;
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[data-pf-promo-click]');
    if (!target) return;
    const placement = target.dataset.pfPromoClick;
    if (!['announcement', 'product-details'].includes(placement)) return;
    const details = {campaign_id: config.campaignId, placement};
    document.dispatchEvent(new CustomEvent('pf:promotion-click', {detail: details}));
    const shopify = window.Shopify;
    if (shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    try { Promise.resolve(shopify?.analytics?.publish?.('pf_promotion_click', details)).catch(() => {}); }
    catch { /* Analytics must never block shopping. */ }
  });
})();
